import * as Yup from "yup";

export const schema = Yup.object().shape({
  email: Yup.string()
    .email("Debes ingresar un email válido.")
    .required("Debes ingresar tu email."),
});

interface FormValues {
  email: string;
  reason: string;
}

export const initialValues: FormValues = {
  email: "",
  reason: "",
}; 